import { Modal, Button, Form, Input, Select } from "antd";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  statusDisplayMap,
  getAvailableStatusOptions,
  isStatusFieldDisabled,
} from "./statusUtils";
import { updateDeviceStatusRequest } from "../../redux/deviceRegister/action";

// Function to convert display status back to backend status
const getBackendStatus = (displayStatus) => {
  // Create reverse mapping from statusDisplayMap
  const reverseMap = Object.entries(statusDisplayMap).reduce(
    (acc, [key, value]) => {
      acc[value] = key;
      return acc;
    },
    {}
  );
  return reverseMap[displayStatus] || displayStatus;
};

// Function to convert backend status to display status
const getDisplayStatus = (status) => {
  return statusDisplayMap[status] || status;
};

const EditDeviceModal = ({
  visible,
  device,
  projectNames,
  projectNumber,
  projectId,
  onCancel,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (device) {
      // Split the project string to get project name and number
      const projectInfo = device.Project.split(", ");
      form.setFieldsValue({
        DeviceId: device.DeviceId,
        Status: getDisplayStatus(device.Status),
        Project: projectInfo,
      });
    }
  }, [device, form]);

  console.log(device, "device");

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const currentProject = device.Project;
      const isProjectChangingFromDefault = currentProject === "--";
      console.log(
        {
          values,
          status: getBackendStatus(values.Status),
          names: projectNames[values.Project],
        },
        "vals"
      );
      const statusToSend =
        isProjectChangingFromDefault &&
        projectNames[values.Project] !== "--" &&
        projectNames[values.Project] !== undefined
          ? "PublishReady"
          : getBackendStatus(values.Status);

      dispatch(
        updateDeviceStatusRequest({
          deviceId: device.DeviceId,
          status: statusToSend,
          projectNumber: projectNumber[values.Project],
          projectId: projectId[values.Project],
          projectName: projectNames[values.Project],
        })
      );
      onCancel();
    });
  };

  // Filter function for the Select search
  const filterOption = (input, option) => {
    if (!option || !option.children) return false;
    const childrenText =
      typeof option.children === "string"
        ? option.children
        : String(option.children);
    return childrenText.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  return (
    <Modal
      title="Edit Device"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Save
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical" className="deviceID-editform">
        <Form.Item
          name="DeviceId"
          label="Device ID"
          rules={[{ required: true }]}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item name="Status" label="Status" rules={[{ required: true }]}>
          <Select
            showSearch
            filterOption={filterOption}
            placeholder="Select status"
            disabled={device && isStatusFieldDisabled(device.Status)}
          >
            {device &&
              getAvailableStatusOptions(device.Status).map((statusKey) => (
                <Select.Option
                  key={statusKey}
                  value={statusDisplayMap[statusKey]}
                >
                  {statusDisplayMap[statusKey]}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item name="Project" label="Projects" rules={[{ required: true }]}>
          <Select
            showSearch
            filterOption={filterOption}
            placeholder="Select projects"
          >
            {[...projectNames]
              .map((project, index) => ({
                project,
                projectNumber: projectNumber[index],
                index,
              }))
              .reverse()
              .map(({ project, projectNumber, index }) => (
                <Select.Option key={index} value={index}>
                  {project} (#{projectNumber})
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditDeviceModal;
